import {
    Component,
    ComponentFactoryResolver,
    ElementRef,
    Inject,
    Injector,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { CMPS_DIALOG_DATA } from '@cmps/ng-uikit';

import { TranslationKeyMap } from './event-centre-c-pop-dialog.i18n';
import { applyStyles } from './function/apply-styles.function';
import { CPopMapItem } from './model/c-pop-map-item.model';
import { deflate, inflate } from './template-inflater';

@Component({
    selector: 'cmps-event-centre-c-pop-dialog',
    templateUrl: './event-centre-c-pop-dialog.component.html',
    host: {
        class: 'cmps-event-centre-c-pop-dialog cmps-cdk-pos-relative cmps-cdk-d-block',
    },
})
export class EventCentreCPopDialogComponent implements OnInit, OnDestroy {
    /** @private */
    _i18n = TranslationKeyMap;

    /** @private */
    _mapItem: CPopMapItem | null;

    /** @private */
    _multiple: boolean | null;

    /** @private */
    _pos: number | null;

    /** @private */
    _progress: number | null;

    @ViewChild('containerRef', { read: ElementRef, static: true })
    private readonly _containerRef: ElementRef<HTMLElement>;

    @ViewChild('ref', { read: ViewContainerRef, static: true })
    private readonly _ref: ViewContainerRef;

    constructor(
        private readonly _injector: Injector,
        private readonly _factoryResolver: ComponentFactoryResolver,
        /** @private */ @Inject(CMPS_DIALOG_DATA)
        readonly _data: CPopMapItem[],
    ) {}

    ngOnInit(): void {
        this._switch('right');
    }

    ngOnDestroy(): void {}

    /** @private */
    _onLeftClick(): void {
        this._switch('left');
    }

    /** @private */
    _onRightClick(): void {
        this._switch('right');
    }

    private _switch(direction: 'left' | 'right'): void {
        deflate(this._ref);

        const index = this._data.indexOf(this._mapItem);
        let nextIndex: number | null = null;
        if (direction === 'left') {
            nextIndex = index - 1 < 0 ? this._data.length - 1 : index - 1;
        }
        if (direction === 'right') {
            nextIndex = index + 1 > this._data.length - 1 ? 0 : index + 1;
        }

        this._mapItem = this._data?.[nextIndex];
        this._multiple = this._data.length > 1;
        this._pos = nextIndex + 1;
        this._progress = (100 / this._data.length) * (nextIndex + 1);

        if (
            this._mapItem.tpl.elementContainerStyles == null ||
            Object.keys(this._mapItem.tpl.elementContainerStyles).length === 0
        ) {
            this._containerRef.nativeElement.classList.add(
                'cmps-event-centre-c-pop-dialog--elements',
            );
        }

        applyStyles(
            this._containerRef.nativeElement,
            this._mapItem.tpl.elementContainerStyles,
        );

        inflate(
            this._injector,
            this._factoryResolver,
            this._ref,
            this._mapItem.tpl,
        );
    }
}
